import { Outlet } from '@tanstack/react-router';

import LanguageSwitcher from '@/components/LanguageSwitcher.tsx';
import ThemeSwitcher from '@/components/ThemeSwitcher.tsx';

export const Route = createFileRoute({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-neutral-50 sm:bg-neutral-50 dark:bg-neutral-900 sm:dark:bg-neutral-900">
      {/* Language and Theme Switchers */}
      <div className="absolute top-4 right-4 z-10 flex items-center gap-2">
        <ThemeSwitcher />
        <LanguageSwitcher />
      </div>
      <div className="absolute top-1/2 left-1/2 hidden -translate-x-1/2 -translate-y-1/2 sm:block">
        <div className="absolute -top-[400px] -left-[400px] h-[800px] w-[800px] rounded-full bg-gradient-to-br from-blue-400/30 to-purple-400/30 blur-3xl filter dark:from-blue-400/20 dark:to-purple-400/20" />
        <div className="absolute -top-[400px] -right-[400px] h-[800px] w-[800px] rounded-full bg-gradient-to-br from-blue-400/30 to-purple-400/30 blur-3xl filter dark:from-blue-400/20 dark:to-purple-400/20" />
      </div>
      <div className="relative h-screen w-full sm:mx-auto sm:h-full sm:max-w-[480px]">
        <div className="flex h-full w-full items-center justify-center bg-white py-8 sm:items-start sm:rounded-xl sm:bg-white/80 sm:py-12 sm:shadow-xl sm:backdrop-blur-lg dark:bg-neutral-800 sm:dark:bg-neutral-800/80">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
